export default __webpack_public_path__ + "static/media/node-js-logo.931ab7d7.svg";